// app/javascript/controllers/promo_redeem_controller.js
import { Controller } from "@hotwired/stimulus";
import Swal from "sweetalert2";

export default class extends Controller {
    static targets = ["input"];
    static values  = { partyId: Number };

    submit(e) {
        e.preventDefault();
        const code = (this.inputTarget.value || "").trim().toUpperCase();
        if (!code) return;

        Swal.fire({
            toast: true, icon: "info", title: "Checking promo code…",
            position: "bottom-end", timer: 0, showConfirmButton: false
        });

        fetch("/party_dashboard/redeem", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
            },
            body: JSON.stringify({ promo_code: code, party_id: this.partyIdValue })
        })
            .then(r => r.json().then(j => ({ ok: r.ok, j })))
            .then(({ ok, j }) => {
                if (ok && j.ok) {
                    Swal.fire({
                        icon: "success",
                        title: "Promo code has been accepted",
                        confirmButtonText: "OK"
                    }).then(() => window.location.reload());
                } else {
                    Swal.fire({
                        icon: "error",
                        title: j?.message || "This promo code doesn't seem valid",
                        confirmButtonText: "OK"
                    });
                }
            })
            .catch(() => {
                Swal.fire({ icon: "error", title: "Network error. Please try again." });
            });
    }
}